// extracted by mini-css-extract-plugin
module.exports = {"stats":"StatsWrapper_stats__1ry6O","statsTitle":"StatsWrapper_statsTitle__3V0ce","statsBody":"StatsWrapper_statsBody__2LWGC"};